module.exports = __webpack_public_path__ + "img/placeholder2.ff20239f.jpg";